/**
 * Charts
 *
 *   - content engagement chart
 */
module.exports = {
    sentimentDataProcessor: null,
    chartsUrl: null,

    /**
     * @var [] default options
     */
    options: {
        sentiment: {
            series: {
                pie: {
                    show: true,
                    radius: 1,
                    label: {
                        show: true,
                        radius: 0.8,
                        threshold: 0.1,
                    },
                    innerRadius: 0.5,
                },
            },
            legend: {
                show: true,
            },
            grid: {
                hoverable: true,
                clickable: true,
            },
            colors: ['#99c660', '#e99f3e', '#e43228'],
            tooltip: true,
            tooltipOpts: {
                content: '%p.0%, %s',
                cssClass: 'flotTip',
                defaultTheme: false,
                shifts: {
                    x: 20,
                    y: 0,
                },
            },
        },
        portal: {
            series: {
                pie: {
                    combine: {
                        color: '#999',
                        threshold: 0.05,
                    },
                    label: {
                        //formatter: "labelFormatter"
                        radius: 0.6,
                        show: true,
                        threshold: 0.1,
                    },
                    radius: 1,
                    show: true,
                },
            },
            legend: {
                show: true,
            },
            grid: {
                clickable: true,
                hoverable: true,
            },
            colors: ['#99c660', '#e99f3e', '#e43228'],
            tooltip: true,
            tooltipOpts: {
                content: '%p.0%, %s',
                cssClass: 'flotTip',
                defaultTheme: false,
                shifts: {
                    x: 20,
                    y: 0,
                },
            },
        },
        engagement: {
            grid: {
                borderWidth: 1,
                borderColor: '#eee',
                tickColor: '#f9f9f9',
                hoverable: true,
            },
            series: {
                lines: {
                    fill: true,
                    lineWidth: 1,
                    show: true,
                },
                points: {
                    show: true,
                    // symbol: 'diamond',
                },
            },
            yaxis: {},
            xaxis: {
                minTickSize: [1, 'day'],
                mode: 'time',
                timeBase: 'milliseconds',
                timeformat: '%d/%m/%Y',
                timezone: 'browser',
            },
            selection: {
                mode: 'x',
            },
        },
        common: {
            chart_overview: false,
            overview_id: 'website-stats-overview',
        },
    },

    initSentimentChart(dataProcessor) {},

    /**
     * Generate url to engagement data based on the project or mode
     *
     * @var string slug Project slug for url
     * @var string name Project name or 'All'
     */
    getEngagementDataUrl(type, typeId) {
        let endDate = null;
        if (moment().isAfter(window.endDate)) {
            endDate = window.endDate.format('YYYY-MM-DD');
        } else if (window.ca.dashboards.content_engagement_chart.include_current_day) {
            endDate = moment().format('YYYY-MM-DD');
        } else {
            endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
        }

        let urlParams = {
            client: ca.client.base_url,
            startDate: window.startDate.format('YYYY-MM-DD'),
            endDate: endDate,
        };

        let baseSrc = '';
        let routeKey = '';

        if (type === 'interactive') {
            routeKey = 'analyse.realtime.api';
            urlParams.type = 'interactive';
            urlParams.project = ca.project.slug;

            if (!!typeId) {
                urlParams.interactive = typeId; // the interactive id
            }

            urlParams.action = 'getContentEngagementChart';
        }

        if (type === 'global') {
            routeKey = 'clients.api.call';
            urlParams.action = 'getGlobalContentEngagementChart';
        }

        if (type === 'project') {
            routeKey = 'projects.api.call';
            if (!!typeId) {
                urlParams.project = typeId;
            } else {
                urlParams.project = ca.project.slug;
            }
            urlParams.action = 'getContentEngagementChart';
        }

        baseSrc = route(routeKey, urlParams);

        return baseSrc;
    },

    getSortListChartUrl(id) {
        return ca.api.url + '/forms/' + id + '/sort-list-results';
    },

    initContentEngagementChart(type, typeId, dataProcessor) {
        let dataUrl = ca.charts.getEngagementDataUrl(type, typeId);
        console.log('ca.charts: using dataUrl', dataUrl);

        $.ajax({
            url: dataUrl,
        }).done(function (data) {
            if (!!dataProcessor) {
                data = dataProcessor(data);
            }

            // @todo-r4: no longer relevant
            $('#engagementPortlet .panel-disabled').remove();

            var options = ca.charts.options.engagement;
            options = {
                ...options,
                tooltip: true,
                tooltipOpts: {
                    lines: true,
                    content: function (label, xval, yval, flotItem) {
                        var groupData = [];

                        //if (flotItem.seriesIndex > 0) {
                        $.each(data, function (dataKey, dataValue) {
                            if (dataValue.label == 'Events') {
                                return true;
                            }

                            if (typeof dataValue.data === 'undefined') {
                                return;
                            }

                            var thisGroup = {
                                label: dataValue.label,
                                value: 0,
                                color: dataValue.color,
                            };

                            // If this particular series has data at all we need to loop over it...
                            if (dataValue.data.length) {
                                $.each(dataValue.data, function (k, v) {
                                    // If this piece of data is for the target date we want to use it
                                    if (v[0] == xval) {
                                        // skip empty
                                        if (v[1] === 0) {
                                            return;
                                        }

                                        thisGroup.value = v[1];

                                        // No point in working further through the array, break the loop.
                                        return false;
                                    }
                                });
                            }

                            groupData.push(thisGroup);
                        });

                        var $output = $('<div/>')
                            .addClass('tooltip-container')
                            .html('<h5>' + moment(xval).format('DD/MM/YYYY') + '</h5>');

                        $.each(groupData, function (k, v) {
                            if (v.value != 0) {
                                $('<div/>')
                                    .addClass('tooltip-row')
                                    .html(
                                        '<span><i class="fas fa-circle" style="color: ' +
                                            v.color +
                                            '"></i> ' +
                                            v.label +
                                            '</span>: ' +
                                            v.value
                                    )
                                    .appendTo($output);
                            }
                        });
                        //}

                        return $output.prop('outerHTML');
                    },
                    shifts: {
                        x: -60,
                        y: 25,
                    },
                    defaultTheme: false,
                },
            };

            var datasets = [];

            $.each(data, function (key, val) {
                datasets.push(data[key]);
            });

            data = datasets;
            if (data.length > 0) {
                window.plot = $.plot('#website-stats', data, options);
                var max = plot.getAxes().yaxis.max;
                var series = plot.getData();

                series.forEach((stat) => {
                    if (stat.label == 'Events') {
                        if (stat.data.length) {
                            plot.getOptions().grid.markings = [];
                            stat.lines.show = false;
                            for (i = 0; i < stat.data.length; i++) {
                                // set the y-axis to the max, full height of the chart
                                // stat.data[i][1] = max;
                                xFrom = stat.data[i][0];
                                xTo = stat.data[i][0];
                                if (stat.names && stat.names[i]) {
                                    xFrom = stat.names[i].start_time;
                                    xTo = stat.names[i].end_time;
                                }

                                plot.getOptions().grid.markings.push({
                                    hoverable: true,
                                    xaxis: {
                                        from: xFrom,
                                        to: xTo,
                                    },
                                    yaxis: {
                                        from: 0,
                                        //to: stat.data[i][1],
                                        to: max,
                                    },
                                    color: 'red',
                                    fillColor: { colors: [{ opacity: 0.8 }, { opacity: 0.4 }] },
                                    highlightColor: 'red',
                                });
                            }
                        }
                    }
                });

                plot.setData(series);
                plot.draw();

                $('<div id="plot-tooltip"></div>')
                    .css({
                        position: 'absolute',
                        display: 'none',
                        border: '1px solid #ccc',
                        padding: '2px',
                        'background-color': 'white',
                        opacity: 0.8,
                    })
                    .appendTo('body');

                $('#website-stats').bind('plotselected', function (event, ranges) {
                    // do the zooming
                    $.each(plot.getXAxes(), function (_, axis) {
                        var opts = axis.options;
                        opts.min = ranges.xaxis.from;
                        opts.max = ranges.xaxis.to;
                    });

                    plot.setupGrid();
                    plot.draw();
                    plot.clearSelection();

                    if (ca.charts.options.common.chart_overview) {
                        // don't fire event on the overview to prevent eternal loop
                        overview.setSelection(ranges, true);
                    }
                });

                if (ca.charts.options.common.chart_overview) {
                    if (document.getElementById(ca.charts.options.common.overview_id)) {
                        var overview = $.plot('#' + ca.charts.options.common.overview_id, series, {
                            ...ca.charts.options.engagement,
                            legend: {
                                show: false,
                            },
                        });
                    }
                }

                $('#website-stats').legendSwitch();
                $('#website-stats').bind('plothover', function (event, pos, item) {
                    if (item) {
                        return;
                    }

                    var hideTooltip = true;

                    // you need to save the Flot object for this (here as "plot")
                    $.each(plot.getOptions().grid.markings, function (idx, marking) {
                        if (pos.x > marking.xaxis.from - 20 && pos.x < marking.xaxis.to + 20) {
                            series.forEach((stat) => {
                                if (stat.type == 'event') {
                                    for (i = 0; i < stat.data.length; i++) {
                                        let event = stat.data[i];

                                        if (
                                            (event[0] == marking.xaxis.from && event[0] == marking.xaxis.to) ||
                                            (stat.names[i].start_time == marking.xaxis.from &&
                                                stat.names[i].end_time == marking.xaxis.to)
                                        ) {
                                            // @todo: this is incorrect - 10 hours, but 11 hours DST
                                            var startMoment = moment(stat.names[i].start_time).subtract('10', 'hours'); //.format('DD/MM/YYYY h:mm:ss a');
                                            var endMoment = moment(stat.names[i].end_time).subtract('10', 'hours'); // .format('DD/MM/YYYY h:mm:ss a');
                                            var eventDate = startMoment.format('DD/MM/YY');

                                            var $output = $('<div/>').addClass('tooltip-container');

                                            if (type === 'global') {
                                                $output.append('<h5>Project: ' + stat.names[i].project_name + '</h5>');
                                            }

                                            $output.append('<h5>' + stat.names[i].name + '</h5>');
                                            $output.append(
                                                '<div><h5>' +
                                                    eventDate +
                                                    ' ' +
                                                    startMoment.format('h:mm a') +
                                                    ' - ' +
                                                    endMoment.format('h:mm a') +
                                                    '</h5></div>'
                                            );
                                            $output.append(
                                                '<div class="datapoint"><i class="fa fa-calendar"></i> Attendees: ' +
                                                    stat.names[i].total_attendees +
                                                    '</div>'
                                            );

                                            $('#plot-tooltip')
                                                .html($output)
                                                .css({ top: pos.pageY + 5, left: pos.pageX + 5 })
                                                .fadeIn(200);
                                        }
                                    }
                                }
                            });

                            hideTooltip = false;
                            return false;
                        }
                    });

                    if (hideTooltip) {
                        $('#plot-tooltip').hide();
                    }
                });

                $('#website-stats').bind('plothovercleanup', function (event, pos, item) {
                    $('#plot-tooltip').hide();
                });
            }
        });
    },
};
